import { COLOR } from 'admin/constants/styles';
import React from 'react';
import Loader from 'react-loader-spinner';

type Props = React.ComponentPropsWithoutRef<typeof Loader>;

const MyLoader = ({ color = COLOR.primaryColor, ...rest }: Props) => {
  return <Loader color={color} {...rest} />;
};

export default MyLoader;
